<div [ngClass]="{'notification' : true, 'notification--is-unread': !isSeen() && isReadable()}">
	<header class="notification__header">
			<ng-content select="app-notification-header"/>
	</header>
	<section class="notification__content">
		<ng-content select="app-notification-content"/>
	</section>
	<section class="notification__operators">
		@if(isReadable()){
		<button class="notification__read-button" mat-icon-button (click)="onReadClick($event)">
			<div class="circle notification__read-button-core"></div>
		</button>
		}
		@if(isDeletable()){
		<button class="notification__delete-button" mat-icon-button (click)="onDeleteClick()">
			<ogs-m3-icon icon="trash-can"/>
		</button>
		}
	</section>
	<footer class="notification__footer">
			<ng-content select="app-notification-footer"/>
	</footer>
</div>

